import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/channels", label: "投稿通道" },
  { to: "/guide", label: "安全投稿指南" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

const channelLinks = [
  { to: "/channels#article", label: "图文投稿通道" },
  { to: "/channels#private", label: "匿名私信投稿" },
  { to: "/channels#video", label: "视频素材上传" },
  { to: "/channels#audio", label: "录音证据提交" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 md:pt-16 pb-8">
        <div className="max-w-content mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50/10 text-background-50 text-lg">
                <i className="ri-mic-line"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold text-background-50">潜声投稿</span>
                <span className="text-[11px] mt-1 tracking-[0.2em] text-primary-300">
                  ANONYMOUS TIPS
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-300/90">
              面向公众的匿名爆料投稿平台。提供图文、私信、视频、录音四类投稿通道，以隐私优先的方式，帮助你安全发声、快速直达编辑。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-accent-300">
                <i className="ri-shield-check-line"></i>
              </span>
              <span className="text-sm text-background-200">全程可匿名 · 无强制实名</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <a href="#site-quick-nav" className="hover:text-accent-300 transition-colors">
                快速导航
              </a>
            </h4>
            <ul id="site-quick-nav" className="mt-5 space-y-3 text-sm">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-background-300/90 hover:text-accent-300 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <a href="#site-channel-nav" className="hover:text-accent-300 transition-colors">
                投稿通道
              </a>
            </h4>
            <ul id="site-channel-nav" className="mt-5 space-y-3 text-sm">
              {channelLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-background-300/90 hover:text-accent-300 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <a href="#site-contact" className="hover:text-accent-300 transition-colors">
                联系方式
              </a>
            </h4>
            <ul id="site-contact" className="mt-5 space-y-3 text-sm text-background-300/90">
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-300 mt-0.5">
                  <i className="ri-mail-line"></i>
                </span>
                <span>投稿与咨询邮箱：tips@qiansheng.online</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-300 mt-0.5">
                  <i className="ri-chat-private-line"></i>
                </span>
                <span>仅通过匿名私信通道沟通，无实体接待地址</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-300 mt-0.5">
                  <i className="ri-time-line"></i>
                </span>
                <span>工作日内平均 6 小时响应，节假日顺延</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-content mx-auto mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-400 leading-relaxed">
            © {year} 潜声投稿 · 本站为信息接洽平台，刊发内容以事实核实为准，不构成任何法律意见。
          </p>
          <p className="text-xs text-background-400 leading-relaxed">
            请勿在公开社交平台讨论你的投稿内容，安全从沉默开始。
          </p>
        </div>
      </div>
    </footer>
  );
}